import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { defaultTo } from 'ramda';
import { withFormik } from 'formik';
import Select from 'react-select';
import moment from 'moment';

import { apiUpdateProfile, apiDeleteAddress } from '../../../api/user';
import { handleError, handleErrorBase, handleSuccess } from '../../../util/forms';

import AddressModal from '../../../components/Modal/AddressModal';
import Radio from '../../../components/Forms/Radio';
import FancyRadio from '../../../components/Forms/FancyRadio';
import Avatar from '../../../components/Avatar';
import EditField from '../../../components/Forms/EditField';
import ResizeAvatarModal from '../../../components/Modal/ResizeAvatarModal';

const propTypes = {
  updateUser: PropTypes.func,
  updateUserAddresses: PropTypes.func,
  user: PropTypes.object,
};

class ContactInfo extends Component {
  state = {
    showAddressModal: false,
    address: {},
    avatar: null,
    showAvatarModal: false,
    src: null,
  };

  onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const img = e.target.files[0];
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        () => this.setState({ avatar: img, showAvatarModal: true, src: reader.result }),
        false,
      );
      reader.readAsDataURL(img);
    }
    e.target.value = null;
  };

  render() {
    const {
      values,
      handleBlur,
      handleChange,
      handleSubmit,
      isSubmitting,
      isValid,
      setFieldValue,
      status,
      user,
      updateUserAddresses,
    } = this.props;
    const { address, showAddressModal, avatar, showAvatarModal, src } = this.state;

    return (
      <form>
        <h2>Profile Image</h2>
        <div className="row my-3">
          <div className="col d-flex flex-column flex-md-row align-items-center">
            <Avatar src={user.avatar} className="m-auto m-md-0" />
            <label className="btn btn-secondary m-2">
              Change Image <input type="file" hidden onChange={this.onSelectFile} />
            </label>
          </div>
        </div>

        <hr />

        <h2>Account Details</h2>
        <EditField
          name="firstName"
          label="First Name"
          required
          status={status}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.firstName}
        />
        <EditField
          name="middleName"
          label="Middle Name"
          status={status}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.middleName}
        />
        <EditField
          name="lastName"
          label="Last Name"
          required
          status={status}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.lastName}
        />
        <EditField
          name="suffix"
          label="Suffix"
          status={status}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.suffix}
        />
        <EditField
          name="dateOfBirth"
          label="Date of Birth"
          type="date"
          status={status}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.dateOfBirth}
        />
        <EditField
          as={Select}
          bare
          simpleValue
          name="gender"
          label="Gender"
          onChange={(value) => setFieldValue('gender', value)}
          options={[
            { label: 'Female', value: 'female' },
            { label: 'Male', value: 'male' },
            { label: 'Non-binary / third gender', value: 'non-binary' },
            { label: 'Prefer not to say', value: 'non-answer' },
          ]}
          value={values.gender}
        />
        <EditField
          as={Select}
          bare
          simpleValue
          name="ethnicity"
          label="Race / Ethnicity"
          onChange={(value) => setFieldValue('ethnicity', value)}
          options={[
            { label: 'Non-Hispanic White or Euro-American', value: 'Non-Hispanic White or Euro-American' },
            {
              label: 'Black, Afro-Caribbean, or African American',
              value: 'Black, Afro-Caribbean, or African American',
            },
            { label: 'Latino or Hispanic American', value: 'Latino or Hispanic American' },
            { label: 'East Asian or Asian American', value: 'East Asian or Asian American' },
            { label: 'South Asian or Indian American', value: 'South Asian or Indian American' },
            { label: 'Middle Eastern or Arab American', value: 'Middle Eastern or Arab American' },
            { label: 'Native American or Alaskan Native', value: 'Native American or Alaskan Native' },
            { label: 'Multi-Racial', value: 'Multi-Racial' },
            { label: 'Prefer not to answer', value: 'Prefer not to answer' },
          ]}
          value={values.ethnicity}
        />
        <EditField
          name="website"
          label="Website"
          type="url"
          status={status}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.website}
        />

        <hr />

        <h2>Preferred Contact</h2>
        <div className="form-group row">
          <label className="col-md-3 col-form-label">Contact Method</label>
          <div className="col-md-7">
            <Radio
              inline
              name="contactMethod"
              label="Email (On Account Settings)"
              value="0"
              checked={values.contactMethod}
              onBlur={handleBlur}
              onChange={handleChange}
            />
            <Radio
              inline
              name="contactMethod"
              label="Work Phone"
              value="1"
              checked={values.contactMethod}
              onBlur={handleBlur}
              onChange={handleChange}
            />
            <Radio
              inline
              name="contactMethod"
              label="Home Phone"
              value="2"
              checked={values.contactMethod}
              onBlur={handleBlur}
              onChange={handleChange}
            />
          </div>
        </div>
        <EditField
          name="homePhone"
          label="Home Phone"
          type="tel"
          status={status}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.homePhone}
        />
        <EditField
          name="workPhone"
          label="Work Phone"
          type="tel"
          status={status}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.workPhone}
        />

        <hr />

        <div className="row">
          <h2 className="col-md-4">Addresses</h2>
          <div className="col-md-6 text-md-right">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => this.setState({ showAddressModal: true })}
            >
              Add New Address
            </button>
          </div>
          {user.addresses.length > 0 && (
            <Fragment>
              <h4 className="col-md-10 mt-3">Choose primary address:</h4>
              {user.addresses.map((address) => (
                <FancyRadio
                  key={address.id}
                  name="primaryAddressId"
                  className="col-md-10"
                  label={address.name}
                  value={address.id}
                  checked={values.primaryAddressId}
                  onBlur={handleBlur}
                  onChange={handleChange}
                >
                  <div>
                    {address.addressLine1}
                    <br />
                    {address.addressLine2}
                    {address.addressLine2 && <br />}
                    {address.city}, {address.state} {address.zip} {address.country}
                  </div>
                  <div className="text-md-right mt-1">
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={() => this.setState({ showAddressModal: true, address: address })}
                    >
                      Edit
                    </button>
                    |
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={() =>
                        apiDeleteAddress(address.id)
                          .then(({ data }) => updateUserAddresses(data))
                          .catch((err) => handleErrorBase('Could not delete address.'))
                      }
                    >
                      Delete
                    </button>
                  </div>
                </FancyRadio>
              ))}
            </Fragment>
          )}
        </div>

        <hr />
        <div className="form-group row row mb-0">
          <div className="col-md-6 offset-md-4 text-right">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={!isValid || isSubmitting}
              onClick={handleSubmit}
            >
              Save Changes
            </button>
          </div>
        </div>
        <AddressModal
          address={address}
          show={showAddressModal}
          onHide={() => this.setState({ showAddressModal: false, address: {} })}
          user={user}
        />
        <ResizeAvatarModal
          avatar={avatar}
          src={src}
          show={showAvatarModal}
          onHide={() => this.setState({ showAvatarModal: false, avatar: null, src: null })}
        />
      </form>
    );
  }
}

ContactInfo.propTypes = propTypes;

export default withFormik({
  handleSubmit: (payload, formProps) => {
    const { props } = formProps;

    apiUpdateProfile(payload)
      .then(({ data }) => props.updateUser(data))
      .then(() => handleSuccess(formProps))
      .catch((err) => handleError(formProps, err));
  },
  mapPropsToValues: ({ user }) => ({
    firstName: defaultTo('', user.firstName),
    middleName: defaultTo('', user.middleName),
    lastName: defaultTo('', user.lastName),
    suffix: defaultTo('', user.suffix),
    dateOfBirth: defaultTo('', moment(user.dateOfBirth).format('YYYY-MM-DD')),
    gender: defaultTo('', user.gender),
    ethnicity: defaultTo('', user.ethnicity),
    website: defaultTo('', user.website),
    email: defaultTo('', user.email),
    password: defaultTo('', user.password),
    passwordConfirmation: defaultTo('', user.passwordConfirmation),
    contactMethod: defaultTo('', user.contactMethod),
    homePhone: defaultTo('', user.homePhone),
    workPhone: defaultTo('', user.workPhone),
    primaryAddressId: defaultTo('', user.primaryAddressId),
  }),
  isInitialValid: true,
  validateOnChange: true,
})(ContactInfo);
